__turbopack_context__.v({
  "Backdrop": "index-module__hwy3yq__Backdrop",
  "Button": "index-module__hwy3yq__Button",
  "CloseButton": "index-module__hwy3yq__CloseButton",
  "Content": "index-module__hwy3yq__Content",
  "Description": "index-module__hwy3yq__Description",
  "Handle": "index-module__hwy3yq__Handle",
  "Header": "index-module__hwy3yq__Header",
  "HeaderSpacer": "index-module__hwy3yq__HeaderSpacer",
  "Item": "index-module__hwy3yq__Item",
  "Link": "index-module__hwy3yq__Link",
  "List": "index-module__hwy3yq__List",
  "LongList": "index-module__hwy3yq__LongList",
  "Panel": "index-module__hwy3yq__Panel",
  "Popup": "index-module__hwy3yq__Popup",
  "ScrollAreaRoot": "index-module__hwy3yq__ScrollAreaRoot",
  "ScrollAreaViewport": "index-module__hwy3yq__ScrollAreaViewport",
  "ScrollContent": "index-module__hwy3yq__ScrollContent",
  "Scrollbar": "index-module__hwy3yq__Scrollbar",
  "ScrollbarThumb": "index-module__hwy3yq__ScrollbarThumb",
  "Title": "index-module__hwy3yq__Title",
  "Viewport": "index-module__hwy3yq__Viewport",
});
